"use client";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { type ComponentProps, useId } from "react";

import { cn } from "../../utils/cn.util";
import { useRadioGroupRootContext } from "./context";
import { indicatorStyles, itemStyles, labelStyles } from "./style";

export interface RadioGroupItemProps extends ComponentProps<typeof RadioGroupPrimitive.Item> {
  color?: "primary" | "error";
}

export const Item = ({ ref, className, color = "primary", ...props }: RadioGroupItemProps) => {
  const { size, disabled } = useRadioGroupRootContext();
  const id = useId();
  const shouldDisabled = props.disabled || disabled;

  return (
    <div className="flex flex-row items-start gap-2">
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(itemStyles({ size, color }), "translate-y-0.5", className)}
        {...props}
        id={props.id ?? id}
      >
        <RadioGroupPrimitive.Indicator forceMount className={indicatorStyles({ size, color })} />
      </RadioGroupPrimitive.Item>

      {props.children ? (
        <label
          htmlFor={props.id ?? id}
          aria-disabled={shouldDisabled}
          className={cn(labelStyles({ size }), "group flex flex-col")}
        >
          {props.children}
        </label>
      ) : null}
    </div>
  );
};

Item.displayName = RadioGroupPrimitive.Item.displayName;
